import { render, staticRenderFns } from "./NairaNoteIcon.vue?vue&type=template&id=30695aa3&"
import script from "./NairaNoteIcon.vue?vue&type=script&lang=js&"
export * from "./NairaNoteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports